import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { Title } from '@angular/platform-browser';
import { ContatoService } from 'src/app/shared/services/contato.service';
import { showFeedbackSuccess } from 'src/app/shared/util/alert-swal';
import { SeoService } from 'src/app/shared/util/seo.service';
import { SessionManager } from 'src/app/shared/util/session-manager';
import { PAGE_TITLE, checkPhoneSintax } from 'src/globals';

@Component({
  selector: 'app-career',
  templateUrl: './career.component.html',
  styleUrls: ['./career.component.scss'],
})
export class CareerComponent implements OnInit {
  fmGroup: UntypedFormGroup;
  // fileBase64: any; // Arquivo do currículo em PDF
  // fileName: string;
  ufs = [
    { nome: 'Acre', sigla: 'AC' },
    { nome: 'Alagoas', sigla: 'AL' },
    { nome: 'Amapá', sigla: 'AP' },
    { nome: 'Amazonas', sigla: 'AM' },
    { nome: 'Bahia', sigla: 'BA' },
    { nome: 'Ceará', sigla: 'CE' },
    { nome: 'Distrito Federal', sigla: 'DF' },
    { nome: 'Espírito Santo', sigla: 'ES' },
    { nome: 'Goiás', sigla: 'GO' },
    { nome: 'Maranhão', sigla: 'MA' },
    { nome: 'Mato Grosso', sigla: 'MT' },
    { nome: 'Mato Grosso do Sul', sigla: 'MS' },
    { nome: 'Minas Gerais', sigla: 'MG' },
    { nome: 'Pará', sigla: 'PA' },
    { nome: 'Paraíba', sigla: 'PB' },
    { nome: 'Paraná', sigla: 'PR' },
    { nome: 'Pernambuco', sigla: 'PE' },
    { nome: 'Piauí', sigla: 'PI' },
    { nome: 'Rio de Janeiro', sigla: 'RJ' },
    { nome: 'Rio Grande do Norte', sigla: 'RN' },
    // { nome: "Rio Grande do Sul", sigla: "RS" },
    { nome: 'Rondônia', sigla: 'RO' },
    { nome: 'Roraima', sigla: 'RR' },
    { nome: 'Santa Catarina', sigla: 'SC' },
    // { nome: "São Paulo", sigla: "SP" },
    { nome: 'Sergipe', sigla: 'SE' },
    { nome: 'Tocantins', sigla: 'TO' },
  ];

  constructor(
    private titleService: Title,
    private formBuilder: UntypedFormBuilder,
    private contatoService: ContatoService,
    private seo: SeoService
  ) {
    this.createForm();
  }

  createForm() {
    this.fmGroup = this.formBuilder.group({
      name: [null, Validators.required],
      phone: [
        null,
        Validators.required,
        Validators.minLength(14),
        Validators.maxLength(15),
        Validators.compose([checkPhoneSintax]),
      ],
      email: [null, Validators.required, Validators.email],
      uf: [null, Validators.required],
      instagram: [null, Validators.required],
      linkedin: [null],
      // 'message': [null, Validators.required],
    });
  }

  ngOnInit(): void {
    this.titleService.setTitle(`Trabalhe conosco - ${PAGE_TITLE}`);

    // Adiciona/Atualiza as Tags ao head da pagina
    this.seo.addTitle(this.titleService.getTitle());
  }

  // /**
  //  * Evento executado quando ocorrer alterações no arquivo
  //  */
  // onFileChange(ev) {
  //     let file = ev.dataTransfer ? ev.dataTransfer.files[0] : ev.target.files[0];
  //     var reader = new FileReader();

  //     reader.onload = (ev: any) => {
  //         let reader = ev.target;
  //         this.fileBase64 = reader.result;
  //     };
  //     reader.readAsDataURL(file);

  //     this.fileName = file.name;
  // }

  onSend() {
    // Valida os campos do form
    if (this.fmGroup.invalid) return;

    const { name, phone, email, uf, instagram, linkedin } = this.fmGroup.value;

    // this.fileBase64
    this.contatoService.enviaTrabalheConosco(name, phone, email, uf, instagram, linkedin).subscribe(
      () => {
        this.fmGroup.reset(); // limpa os campos do form
        // this.fileBase64 = this.fileName = '';
        showFeedbackSuccess('Sua mensagem foi enviada!', 'Agradecemos seu interesse em trabalhar conosco.');
      },
      error => {
        SessionManager.handleHttpError(error, 'Falha ao enviar o contato');
      }
    );
  }
}
